import React from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

const VideoPlay = ({ url = undefined, className, onEnded = () => {} }) => (
  <Container className={className}>
    <Content>
      {url && (
        <ReactPlayer
          url={url}
          controls={true}
          onEnded={onEnded}
          width='100%'
          height='100%'
          config={{
            youtube: {
              playerVars: {
                rel: 0
              }
            }
          }}
        />
      )}
    </Content>
  </Container>
);

const Container = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export default VideoPlay;
